var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 11.433,
    ry: 11.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.24q4.573-4.088 4.573-11.24T12 .76Q7.427 4.848 7.427 12T12 23.24M1.138 8.628h21.724M1.138 15.372h21.724"
  })));
};
export default SvgLanguage;